export default {
  product: {
    title: 'प्रोडक्ट',
    selfCustodyWallet: 'मोबाइल वॉलेट',
    selfCustodyWalletDesc: 'ब्लॉकचेन पर क्रिप्टो और डेफी मोबाइल वॉलेट।',
    hardwareWallet: 'हार्डवेयर वॉलेट',
    hardwareWalletDesc:
      'अपनी संपत्ति की रक्षा के लिए अपना KeyPal प्राप्त करें.',
    extensionWallet: 'एक्सटेंशन वॉलेट',
    extensionWalletDesc: 'आपके कंप्यूटर पर एक बेहतर वॉलेट।',
    transit: 'ट्रांजिट',
    transitDesc: 'मल्टी-चेन DEX एग्रीगेटर और NFT मार्केटप्लेस प्लेटफॉर्म।',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Web3.0 में सोशल नेटवर्क प्रोटोकॉल।',
    stakeVault: 'ETH Staking Vault',
    stakeVaultDesc:
      'स्व-संग्रह स्टेकिंग और छोटी मात्रा स्टेकिंग दोनों का समर्थन करता है',
  },
  project: {
    subToken: 'टोकन जमा करें',
    subDApp: 'DApp जमा करें',
    subNFT: 'NFT जमा करें',
    subChain: 'सार्वजनिक श्रृंखला जमा करें',
  },
  assets: {
    title: 'संपत्ति',
  },
  collaborations: {
    title: 'सहयोग',
  },
  community: {
    title: 'समुदाय',
    developers: 'डेवलपर्स',
    recruiting: 'TP Man',
  },
  helpCenter: {
    title: 'सेवा',
  },
  features: {
    title: 'विशेषताएँ',
    buyCrypto: 'क्रिप्टो खरीदें',
    mobileWallet: 'मोबाइल वॉलेट',
    hardwareWallet: 'हार्डवेयर वॉलेट',
    extensionWallet: 'एक्सटेंशन वॉलेट',
    desktop: 'डेस्कटॉप वॉलेट',
    fiveDegrees: '5Degrees',
    versionVerification: 'Version Verification',
    approvalDetector: 'अनुमोदन डिटेक्टर',
    tokenSecurity: 'टोकन सुरक्षा',
    keyGenerator: 'कुंजी जेनरेटर',
    BATCH_SENDER: 'Batchsender',
  },
  information: {
    title: 'जानकारी',
    blockchainGuide: 'ब्लॉकचेन गाइड',
    tronWallet: 'ट्रॉन गाइड',
    iostWallet: 'IOST गाइड',
    tpMan: 'TP Man',
  },
  developers: {
    title: 'डेवलपर्स',
    github: 'Github (TP-Lab)',
    devCenter: 'डेवलपर केंद्र',
    subToken: 'टोकन जमा करें',
    subDApp: 'DApp जमा करें',
    subNFT: 'NFT जमा करें',
  },
  company: {
    title: 'कंपनी',
    about: 'के बारे में',
    careers: 'करियर',
    pressKit: 'प्रेस किट',
    swagShop: 'स्वैग की दुकान',
  },
  support: {
    title: 'सहायता',
    helpCenter: 'सहायता केंद्र',
    contactUs: 'संपर्क करें',
  },
  legal: {
    title: 'वैध',
    privacyPolicy: 'गोपनीयता नीति',
    terms: 'उपयोग की शर्तें',
  },
  main: {
    title: 'संस्करण सत्यापन',
    language: 'हिंदी',
    intro:
      'संस्करण सत्यापन का कार्य MD5 या SHA256 हैश वैल्यू को संस्करणों के बीच मिलाकर किया जाता है। कृपया याद रखें कि ठगी से बचने के लिए आधिकारिक स्रोतों के माध्यम से TokenPocket वॉलेट डाउनलोड करें। संस्करण के MD5 या SHA256 हैश वैल्यू कैसे प्राप्त करने के लिए निर्देशिका के लिए कृपया ',
    tutorial: 'ट्यूटोरियल देखें >',
    system: 'ओएस',
    android: 'एंड्रॉइड',
    ios: 'आईओएस',
    version: 'संस्करण',
    allVersion: 'सभी',
    appChannel: 'ऐप चैनल',
    developer: 'डेवलपर',
    allChannel: 'सभी',
    md5: 'एमडी5',
    sha256: 'एसएचए256',
    log: 'संस्करण लॉग',
    check: 'विवरण',
    versionLog: 'संस्करण लॉग',
    confirm: 'पुष्टि करें',
    aboutIOS: 'आईओएस संस्करण के बारे में',
    IOSDesc:
      'आईओएस संस्करण के लिए, हम केवल App Store पर हमारा ऐप प्रदान करते हैं। केवल App Store से डाउनलोड की गई ऐप्स को सही ढंग से स्थापित किया जा सकता है। इसलिए, Apple उपयोगकर्ताओं को सुनिश्चित करें कि वे सिर्फ़ App Store को एकमात्र डाउनलोड चैनल के रूप में प्रमाणित करें।',
    IOSDesc_2:
      'App Store से 8 अक्टूबर 2022 से पहले डाउनलोड की गई संस्करण के डेवलपर हैं TOKENPOCKET FOUNDATION LTD, जो TokenPocket द्वारा विकसित एक प्रारंभिक संस्करण है। यह एक वैध वॉलेट है जो सामान्यतः उपयोग किया जा सकता है, लेकिन अपडेट सेवा अस्थायी रूप से निलंबित की जाएगी।',
    aboutAndroid: 'Android संस्करण के बारे में ',
    androidDesc: 'वर्तमान में TokenPocket Android डाउनलोड चैनल शामिल हैं: आधिकारिक वेबसाइट, Google Play स्टोर, Samsung ऐप स्टोर, Huawei ऐप गैलरी, OPPO ऐप स्टोर, Vivo ऐप स्टोर। कुछ एप्लिकेशन स्टोर में डाउनलोड प्रक्रिया के दौरान APK स्थापना पैकेज प्राप्त नहीं किया जा सकता है, इसलिए MD5 या SHA256 गणना सत्यापन नहीं कर सकते। इसलिए, डाउनलोड करते समय, कृपया विकासकर्ता जानकारी की सत्यापन करें और नीचे दिए गए को संदर्भ में लें!',
    IOSAppName: 'ऐप्लिकेशन का नाम:',
    TPWallet: 'टीपी वॉलेट',
    AppIcon: 'ऐप्लिकेशन आइकन:',
    AppDeveloper: 'डेवलपर:',
    downloadLink: 'डाउनलोड लिंक:',
    copied: 'कॉपी किया गया!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'हमारे पर का पालन करें',
    desc1: 'TokenPocket कर्मचारी आपको निजी संदेश नहीं भेजेंगे!',
    desc2:
      'सावधानी! आप टोकनपॉकेट समुदाय में प्रवेश कर रहे हैं, हो सकता है कि कोई व्यक्ति आपको निजी संदेश भेजने के लिए प्रतिरूपित कर रहा हो! कृपया ध्यान रखें कि निजी संदेश भेजने वाला कोई भी व्यक्ति स्कैमर हो सकता है! हम आपसे पहले कभी संपर्क नहीं करेंगे!',
    desc3: 'समझे, दर्ज करें',
  },
};
